import { z } from 'zod'

/**
 * How to play one tree video on a proposal: Stream's iframe player, with the
 * signed token in the URL when playback is signed. Short-lived by design, so
 * a page fetches it when somebody presses play.
 */
export const proposalVideoPlaybackDtoSchema = z.object({
  playbackUrl: z.string().url(),
  thumbnailUrl: z.string().url().nullable(),
})

export type ProposalVideoPlaybackDto = z.infer<
  typeof proposalVideoPlaybackDtoSchema
>

/**
 * Where to download a sent proposal as a PDF: a signed storage link that
 * expires in minutes, so the page asks for it at the moment of download.
 */
export const proposalPdfDtoSchema = z.object({
  url: z.string().url(),
})

export type ProposalPdfDto = z.infer<typeof proposalPdfDtoSchema>
